module.exports = __webpack_public_path__ + "media/components/src/assets/images/before_and_after/before_after_1-99b1aa5c74e9f0cda3802194af06fc15.jpg";